import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const o = (l) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(l),
    children: [
      /* @__PURE__ */ C("g", { clipPath: "url(#clip0_7726_11672)", children: /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7331 0.40756C11.2158 0.480256 10.7998 0.684328 10.4399 1.042C10.3327 1.14846 10.1965 1.31118 10.1372 1.40358C10.0158 1.59256 0.370286 19.3922 0.22703 19.6916C0.0876645 19.9828 0.0408229 20.1664 0.0324915 20.5033L0.0322939 20.5008C0.0273499 20.4385 0.0233899 20.4956 0.0234379 20.6276C0.0235073 20.7539 0.0272047 20.806 0.0317734 20.749C0.0345924 20.9703 0.0465425 21.0664 0.0823819 21.1984C0.328046 22.1028 1.08973 22.7668 2.00133 22.8712C2.28949 22.9042 21.7399 22.9042 22.028 22.8712C22.8005 22.7827 23.4657 22.2998 23.8034 21.5824C23.902 21.3728 23.9907 21.0675 23.9907 20.9372C23.9907 20.8938 24.0015 20.8517 24.0147 20.8436C24.0279 20.8354 24.0387 20.7269 24.0387 20.6008C24.0387 20.4549 24.03 20.3781 24.0147 20.3876C24.0008 20.3962 23.9907 20.3731 23.9907 20.3328C23.9907 20.209 23.8965 19.8885 23.8023 19.6916C23.6606 19.3955 14.0145 1.5941 13.8925 1.40358C13.6623 1.04409 13.2084 0.678472 12.8152 0.535744C12.4869 0.416584 12.0432 0.364 11.7331 0.40756ZM0.0317734 20.749L0.0323899 20.7408C0.0371958 20.672 0.0372143 20.566 0.0324915 20.5033C0.031434 20.5461 0.0309969 20.5913 0.0310699 20.6396C0.0311298 20.6793 0.0313473 20.7156 0.0317734 20.749ZM12.0234 6.50297C11.2779 6.50297 10.6734 7.10739 10.6734 7.85297V10.753V13.653C10.6734 14.3986 11.2779 15.003 12.0234 15.003C12.769 15.003 13.3734 14.3986 13.3734 13.653V7.85297C13.3734 7.10739 12.769 6.50297 12.0234 6.50297ZM13.6484 17.8617C13.6484 18.7592 12.9209 19.4867 12.0234 19.4867C11.126 19.4867 10.3984 18.7592 10.3984 17.8617C10.3984 16.9643 11.126 16.2367 12.0234 16.2367C12.9209 16.2367 13.6484 16.9643 13.6484 17.8617Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_7726_11672", children: /* @__PURE__ */ C(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.0234375 0.392395)"
        }
      ) }) })
    ]
  }
);
export {
  o as SolidAlertIcon
};
//# sourceMappingURL=SolidAlertIcon.js.map
